<template>
  <ValidationObserver ref="form">
    <form v-on:submit.prevent>
      <div class="row">
        <div class="form-group col-md-12">
          <dt-select
            v-model="contactType"
            v-show="showType && !isCompany"
            label="Contact Type"
            name="contactType"
            :options="lookups['ContactType']"
            validate="required"
            @change="saveIt"
          />
          <dt-select
            v-model="salutation"
            v-show="!isCompany"
            label="Salutation"
            name="salutation"
            :options="lookups['Salutation']"
            @change="saveIt"
          />
          <dt-input
            v-model="firstName"
            v-show="!isCompany"
            name="firstName"
            label="First Name"
            :validate="!isCompany ? 'required' : ''"
            @keyup="saveIt"
          />
          <dt-input
            v-model="lastName"
            name="lastName"
            :label="nameLabel"
            validate="required"
            @keyup="saveIt"
          />
          <dt-select
            v-model="timezone"
            label="Time Zone"
            name="timezone"
            :options="lookups['TimeZone']"
            validate="required"
            @change="saveIt"
          />
          <dt-select
            v-model="language"
            label="Language"
            name="language"
            :options="lookups['Language']"
            validate="required"
            @change="saveIt"
          />
          <dt-input
            v-model="insuranceId"
            v-show="isCompany"
            name="insuranceId"
            label="Id #"
            @keyup="saveIt"
          />
          <dt-input
            v-model="insuranceNumber"
            v-show="isCompany"
            name="insuranceNumber"
            label="Reference"
            @keyup="saveIt"
          />
          <dt-textarea
            v-model="notes"
            name="Notes"
            label="Notes"
            @keyup="saveIt"
          />
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DtInput from '@/components/utilities/form/dt-input'
import DtSelect from '@/components/utilities/form/dt-select'
import DtTextarea from '@/components/utilities/form/dt-textarea'
export default {
  name: 'contact',
  props: {
    showType: {
      type: Boolean,
      default: true
    },
    isFirm: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DtInput,
    DtSelect,
    DtTextarea
  },
  watch: {
    contact() {
      console.log('Contact', this.contact)
    }
  },
  computed: {
    ...mapGetters('lookups', ['lookups']),
    ...mapGetters('contacts', ['contact']),
    nameLabel: {
      get() {
        let _label = 'Last Name'
        if (this.isCompany) {
          _label = 'Name'
        }
        return _label
      }
    },
    isCompany: {
      get() {
        return this.contact !== null ? this.contact.isCompany : false
      }
    },
    contactType: {
      get() {
        return this.contact !== null ? this.contact.contactType : 0
      },
      set(value) {
        this.updateContact({ name: 'contactType', value: value })
      }
    },
    salutation: {
      get() {
        return this.contact !== null ? this.contact.salutation : 0
      },
      set(value) {
        this.updateContact({ name: 'salutation', value: value })
      }
    },
    firstName: {
      get() {
        return this.contact !== null ? this.contact.firstName : ''
      },
      set(value) {
        this.updateContact({ name: 'firstName', value: value })
      }
    },
    timezone: {
      get() {
        return this.contact !== null ? this.contact.timezone : ''
      },
      set(value) {
        this.updateContact({
          name: 'timezone',
          value: value
        })
      }
    },
    language: {
      get() {
        return this.contact !== null ? this.contact.language : ''
      },
      set(value) {
        this.updateContact({
          name: 'language',
          value: value
        })
      }
    },
    insuranceId: {
      get() {
        return this.contact !== null ? this.contact.insuranceId : ''
      },
      set(value) {
        this.updateContact({ name: 'insuranceId', value: value })
      }
    },
    insuranceNumber: {
      get() {
        return this.contact !== null ? this.contact.insuranceNumber : ''
      },
      set(value) {
        this.updateContact({ name: 'insuranceNumber', value: value })
      }
    },
    lastName: {
      get() {
        return this.contact !== null ? this.contact.lastName : ''
      },
      set(value) {
        this.updateContact({ name: 'lastName', value: value })
      }
    },
    notes: {
      get() {
        return this.contact !== null ? this.contact.notes : ''
      },
      set(value) {
        this.updateContact({ name: 'notes', value: value })
      }
    }
  },
  methods: {
    ...mapActions('contacts', ['updateContact', 'saveContact']),
    saveIt() {
      this.$emit('highlightSave', true)
    },
    onSubmit() {},
    async performSave() {
      return this.$refs.form.validate().then(async success => {
        let valid = true
        if (!success) {
          valid = false
        }
        if (this.contact.timezone === 0) {
          valid = false
        }
        if (this.contact.language === 0) {
          valid = false
        }
        if (valid) {
          let data = {
            firm: this.contact.firm,
            isFirm: this.isFirm,
            contact:
              this.contact.contact !== undefined &&
              this.contact.contact !== null
                ? this.contact.contact
                : null,
            firstName: this.contact.firstName,
            lastName: this.contact.lastName,
            contactType: this.contact.contactType,
            salutation:
              this.contact.salutation !== ''
                ? parseInt(this.contact.salutation)
                : '',
            timezone: this.contact.timezone,
            language: this.contact.language,
            notes: this.contact.notes
          }
          this.updateContact({ name: 'isFirm', value: this.isFirm })
          console.log('Saving Contact', data)
          await this.saveContact(data)
          return true
        } else {
          console.log('Validation Failed on Saving Contact')
          return false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contacts/forms/contact.vue